<app-page-frame frameTitle="Training" titleIcon="bi-rocket-takeoff" homeRoute="/training">
  <router-outlet></router-outlet>
</app-page-frame>

